const VENDOR_ACTION_TYPES = {
  LOAD_VENDORS: 'vendorStore/LOAD_VENDORS',
};

export default VENDOR_ACTION_TYPES;
